import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';

const classes = {
	closeButton: 'js-m-prompt-box__close',
	statePromptHide: 'state-m-prompt-box--hidden',
};

@createModule('PromptBox')
/**
 * prompt-box
 */
export class PromptBox extends TerrificSpec {
	$ctx: JQuery;
	$closeButton: JQuery;

	start(resolve: Function) {
		this.$ctx = $(this._ctx);
		this.$closeButton = $(`.${classes.closeButton}`, this.$ctx);

		this.$closeButton.on('click', this.hidePrompt.bind(this));

		resolve();
	}

	hidePrompt() {
		$(this._ctx).addClass(classes.statePromptHide);
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() { }
}
